import { cn } from '../../utils/cn'

// Hero dos playbooks Working Backwards. Defaults = tema Nex2AI.
// variant="omnicore" usa as posições do frame 585:9054 e o subtítulo em dois
// níveis (Inter 24px + 16px) — no Nex2AI o subtítulo é único, em Titillium.
export default function BackwardsHero({
  variant = 'nex2ai',
  bgImage = '../assets/backwards/hero-bg.png',
  logo = '../assets/backwards/nex2ai-logo.svg',
  logoAlt = 'nex2ai',
  eyebrow = 'Material de Apoio',
  title = 'Domine a Narrativa AI-First.',
  titleHighlight = 'Organizacional.',
  subtitle = 'Transformamos organizações com estratégia, execução e cultura AI-First, do Mapa de Maturidade ao Squad Gerenciado que entrega resultado real.',
  subtitle2 = '',
  badgeTitle = 'playbook',
  badgeText = 'Material tático para você dominar o nosso ecossistema de serviços.',
}) {
  const isOmnicore = variant === 'omnicore'

  return (
    <section
      className="relative w-full overflow-hidden bg-[#330105] bg-cover bg-center text-white"
      style={{ backgroundImage: `url('${bgImage}')` }}
    >
      {/* Mobile: empilhado com padding. Desktop (lg+): posições exatas do frame (1440x1024). */}
      <div className="relative mx-auto flex w-full max-w-[1440px] flex-col gap-8 px-6 py-12 lg:block lg:h-[1024px] lg:gap-0 lg:px-0 lg:py-0">
        <img
          src={logo}
          alt={logoAlt}
          className={cn(
            'h-9 w-auto lg:absolute',
            isOmnicore
              ? 'lg:left-[98px] lg:top-[84px] lg:h-[61px]'
              : 'lg:left-[57px] lg:top-[57px] lg:h-[35px]',
          )}
        />

        <div
          className={cn(
            'flex items-center gap-[7px] lg:absolute',
            isOmnicore
              ? 'lg:left-[103px] lg:top-[296px]'
              : 'lg:left-[191px] lg:top-[292px]',
          )}
        >
          <span className="h-0.5 w-6 shrink-0 bg-white" />
          <span className="font-titillium-web-regular text-2xl text-white">
            {eyebrow}
          </span>
        </div>

        <h1
          className={cn(
            'max-w-[995px] font-titillium-web-bold text-5xl leading-none tracking-[-0.03em] text-white lg:absolute lg:text-[82px]',
            isOmnicore
              ? 'lg:left-[99px] lg:top-[341px]'
              : 'lg:left-[188px] lg:top-[329px]',
          )}
        >
          {title}{' '}
          <span
            className="text-transparent"
            style={{ WebkitTextStroke: '1px #ffffff' }}
          >
            {titleHighlight}
          </span>
        </h1>

        {isOmnicore ? (
          <>
            <p className="max-w-[499px] font-inter-regular text-xl leading-none tracking-[-0.033em] text-white lg:absolute lg:left-[99px] lg:top-[595px] lg:text-2xl">
              {subtitle}
            </p>
            {subtitle2 && (
              <p className="max-w-[680px] font-inter-regular text-base leading-[1.08] tracking-[-0.02em] text-white lg:absolute lg:left-[98px] lg:top-[663px]">
                {subtitle2}
              </p>
            )}
          </>
        ) : (
          <p className="max-w-[771px] font-titillium-web-regular text-xl leading-snug text-white lg:absolute lg:left-[191px] lg:top-[535px] lg:text-2xl lg:leading-[26px]">
            {subtitle}
          </p>
        )}

        {(badgeTitle || badgeText) && (
          <div className="flex items-start gap-[31px] lg:absolute lg:bottom-[114px] lg:right-[41px]">
            <div className="flex flex-col items-end text-right">
              {badgeTitle && (
                <span
                  className={cn(
                    'font-titillium-web-semibold text-lg text-white',
                    isOmnicore && 'uppercase',
                  )}
                >
                  {badgeTitle}
                </span>
              )}
              {badgeText && (
                <p
                  className={cn(
                    'font-titillium-web-regular text-base leading-tight text-white',
                    isOmnicore ? 'w-[280px]' : 'w-[241px]',
                  )}
                >
                  {badgeText}
                </p>
              )}
            </div>

            <svg
              width="13"
              height="67"
              viewBox="0 0 13 67"
              fill="none"
              className="shrink-0"
              role="presentation"
              aria-hidden="true"
            >
              <title>seta</title>
              <path d="M6.5 0 V64" stroke="white" strokeWidth="1" />
              <path
                d="M1 59 L6.5 65.5 L12 59"
                stroke="white"
                strokeWidth="1"
                fill="none"
              />
            </svg>
          </div>
        )}
      </div>
    </section>
  )
}
